<template>
  <v-toolbar dark :color="color" elevation="0" rounded="0">
    <v-toolbar-title class="d-flex justify-start align-center font-weight-bold px-0">
      <v-icon v-if="!isMobile" class="mr-4">{{ icon }}</v-icon>
      {{ title }}
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <ClientDropdown
      v-if="!hideClientDropdown"
      class="client-dropdown"
      :disabled="disableClientDropdown"
    ></ClientDropdown>
    <v-btn dark icon large class="ml-4 mr-0" @click="$emit('close')">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
import ClientDropdown from "@/components/ClientDropdown.vue";

import isMobile from "@/mixins/isMobile";

export default {
  name: "Toolbar",
  components: {
    ClientDropdown,
  },
  mixins: [isMobile],
  props: {
    title: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "primary",
    },
    hideClientDropdown: {
      type: Boolean,
      default: true,
    },
    disableClientDropdown: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.client-dropdown {
  max-width: 250px;
}
</style>
